<template>
  <div class="main-content">
<!--    <div class="card region_action_card mb-0">-->
<!--      <div class="card-body p-0">-->
<!--        <div class="flex justify-content-between">-->
<!--          <div class="btn-group" role="group" aria-label="Basic example">-->
<!--            <button v-for="b in tabs" type="button"-->
<!--                    @click="setActive(b.alias)"-->
<!--                    :class="{'btn btn-outline-info': true, 'active': activeTab === b.alias}">{{ b.name }}-->
<!--            </button>-->
<!--          </div>-->
<!--          <button @click="logout" type="button" class="btn btn-outline-success">Выход</button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div :class="{'d-none': activeTab !== 'main'}">
      <h4>Regions Main page</h4>
    </div>
<!--    <iframe :class="{'d-none': activeTab !== 'chat'}" id="chat_frame" width="100%" height="100%"-->
<!--            src="/telegramm"/>-->
  </div>
</template>

<script>

import Auth from "@/services/auth";

export default {
  data() {
    return {
      activeTab: 'main',
      tabs: [{name: 'Главная', alias: 'main'}, {name: 'Чат', alias: 'chat'}]
    }
  },
  methods: {
    setActive(alias) {
      this.activeTab = alias;
    },
    logout() {
      Auth.logout().then(() => {
        this.mixinGoToRouter('RegionLogin');
      });
    },
  }
}

</script>

<style scoped>
#chat_frame {
  width: 100%;
  height: calc(100vh - 55px);
  border: 0;
}

.card.region_action_card {
  padding: 5px;
}
</style>
